export function importAll(r: any) {
  return r.keys().reduce((acc: any, item: any) => {
    if (item.replace("./", "").includes("/")) {
      acc[item.replace("./", "")] = r(item);
    }
    return acc;
  }, {});
}
